import React from "react";

const Gallery = () => {
  const galleryItems = [
    {
      src: "/assets/allprojects.jpeg",
      title: "सभी प्रोजेक्ट्स",
      description:
        "हमारे सभी शहर सफाई और पर्यावरण संरक्षण प्रोजेक्ट्स का संकलन",
      category: "प्रोजेक्ट्स",
    },
    // Project Taru Images
    {
      src: "/assets/taru/image.png",
      title: "Project तरु - वृक्षारोपण",
      description: "1500+ पौधों का रोपण और संरक्षण कार्यक्रम",
      category: "वृक्षारोपण",
    },
    {
      src: "/assets/taru/image1.png",
      title: "तरु प्रोजेक्ट की गतिविधियां",
      description: "पौधों की देखभाल और पोषण कार्यक्रम",
      category: "देखभाल",
    },
    {
      src: "/assets/taru/image2.png",
      title: "पर्यावरण संरक्षण अभियान",
      description: "स्थानीय समुदाय के साथ मिलकर वृक्षारोपण",
      category: "सामुदायिक कार्य",
    },
    {
      src: "/assets/taru/image3.png",
      title: "स्वच्छता एवं वृक्षारोपण",
      description: "स्वच्छता अभियान के साथ हरियाली का विस्तार",
      category: "स्वच्छता",
    },
    // Project Nirmal Images
    {
      src: "/assets/projectnirmal/1.png",
      title: "निगमित स्वच्छता अभियान - भाग 1",
      description: "अम्बेडकर तालाब क्षेत्र की सफाई",
      category: "स्वच्छता",
    },
    {
      src: "/assets/projectnirmal/2.png",
      title: "निगमित स्वच्छता अभियान - भाग 2",
      description: "गौरीघाट बाढ़ क्षेत्र की सफाई",
      category: "स्वच्छता",
    },
    {
      src: "/assets/projectnirmal/3.png",
      title: "निगमित स्वच्छता अभियान - भाग 3",
      description: "कटंगा बाढ़ क्षेत्र की व्यापक सफाई",
      category: "स्वच्छता",
    },
    {
      src: "/assets/projectnirmal/4.png",
      title: "निगमित स्वच्छता अभियान - भाग 4",
      description: "भर्रूखर बाढ़ क्षेत्र की सफाई",
      category: "स्वच्छता",
    },
    {
      src: "/assets/projectnirmal/5.png",
      title: "स्वच्छता जागरूकता कार्यक्रम",
      description: "नागरिकों में स्वच्छता की जागरूकता",
      category: "जागरूकता",
    },
    // Project Nabhchar Images
    {
      src: "/assets/project-nabhchar/1.png",
      title: "अंतरराष्ट्रीय पृथ्वी दिवस - भाग 1",
      description: "केंद्रीय विद्यालय में पर्यावरण शिक्षा",
      category: "शिक्षा",
    },
    {
      src: "/assets/project-nabhchar/2.png",
      title: "अंतरराष्ट्रीय पृथ्वी दिवस - भाग 2",
      description: "बच्चों के साथ पर्यावरण संरक्षण गतिविधियां",
      category: "शिक्षा",
    },
    {
      src: "/assets/project-nabhchar/3.png",
      title: "पोस्टर प्रतियोगिता",
      description: "पर्यावरण विषयक पोस्टर प्रतियोगिता",
      category: "प्रतियोगिता",
    },
    {
      src: "/assets/project-nabhchar/4.png",
      title: "पर्यावरण जागरूकता कार्यक्रम",
      description: "स्कूली बच्चों के साथ जागरूकता अभियान",
      category: "जागरूकता",
    },
    {
      src: "/assets/project-nabhchar/5.png",
      title: "प्राकृतिक संसाधन संरक्षण",
      description: "प्राकृतिक संसाधनों के संरक्षण की शिक्षा",
      category: "संरक्षण",
    },
    // Vasundhara Project Images
    {
      src: "/assets/vasundhara/1.png",
      title: "Project आशियाना - पक्षी घोंसले",
      description: "पक्षियों के लिए घोंसलों का निर्माण",
      category: "पक्षी संरक्षण",
    },
    {
      src: "/assets/vasundhara/2.png",
      title: "पक्षी संरक्षण कार्यक्रम",
      description: "घरेलू स्तर पर पक्षी संरक्षण",
      category: "संरक्षण",
    },
    {
      src: "/assets/vasundhara/3.png",
      title: "प्राकृतिक आवास निर्माण",
      description: "पक्षियों के प्राकृतिक आवास का विकास",
      category: "आवास निर्माण",
    },
    {
      src: "/assets/vasundhara/4.png",
      title: "पारिस्थितिकी संतुलन",
      description: "पक्षियों के माध्यम से पारिस्थितिकी संतुलन",
      category: "संतुलन",
    },
    {
      src: "/assets/vasundhara/5.png",
      title: "वन्यजीव संरक्षण",
      description: "शहरी क्षेत्रों में वन्यजीव संरक्षण",
      category: "वन्यजीव",
    },
    // Project Trapti Images
    {
      src: "/assets/projecttrapti/1.png",
      title: "Project परिवर्तन - प्लास्टिक मुक्ति",
      description: "सिंगल यूज प्लास्टिक के विकल्प",
      category: "प्लास्टिक मुक्ति",
    },
    {
      src: "/assets/projecttrapti/2.png",
      title: "पेपर बैग वितरण",
      description: "प्लास्टिक बैग के स्थान पर पेपर बैग",
      category: "विकल्प",
    },
    {
      src: "/assets/projecttrapti/3.png",
      title: "जागरूकता अभियान",
      description: "प्लास्टिक के हानिकारक प्रभावों की जागरूकता",
      category: "जागरूकता",
    },
    {
      src: "/assets/projecttrapti/4.png",
      title: "पर्यावरण अनुकूल विकल्प",
      description: "पर्यावरण अनुकूल उत्पादों का प्रचार",
      category: "पर्यावरण अनुकूल",
    },
    // Kabaad Se Jugaad Images
    {
      src: "/assets/kabaad-se-jugaad/1.png",
      title: "Project प्यास - पक्षी प्याऊ",
      description: "गर्मी में पक्षियों के लिए पानी की व्यवस्था",
      category: "जल संरक्षण",
    },
    {
      src: "/assets/kabaad-se-jugaad/2.png",
      title: "प्याऊ की स्थापना",
      description: "शहर के विभिन्न स्थानों पर प्याऊ स्थापना",
      category: "स्थापना",
    },
    {
      src: "/assets/kabaad-se-jugaad/3.png",
      title: "जल संरक्षण गतिविधि",
      description: "पक्षियों के लिए नियमित जल व्यवस्था",
      category: "संरक्षण",
    },
    // Wall Paintings Images
    {
      src: "/assets/wallpaintings/1.png",
      title: "Project बनचर - दीवार चित्रकारी",
      description: "पर्यावरण संदेश के लिए दीवार चित्र",
      category: "कला",
    },
    {
      src: "/assets/wallpaintings/2.png",
      title: "सामुदायिक दीवार कला",
      description: "स्वच्छता और पर्यावरण संदेश की कलात्मक प्रस्तुति",
      category: "सामुदायिक कला",
    },
    {
      src: "/assets/wallpaintings/3.png",
      title: "पर्यावरण संदेश चित्र",
      description: "दीवारों पर पर्यावरण संरक्षण के संदेश",
      category: "संदेश",
    },
    {
      src: "/assets/wallpaintings/4.png",
      title: "जागरूकता कला",
      description: "कलात्मक माध्यम से पर्यावरण जागरूकता",
      category: "जागरूकता कला",
    },
    {
      src: "/assets/wallpaintings/5.png",
      title: "शहरी सुंदरीकरण",
      description: "दीवार चित्रकारी के माध्यम से शहर का सुंदरीकरण",
      category: "सुंदरीकरण",
    },
    {
      src: "/assets/wallpaintings.jpeg",
      title: "दीवार चित्रकारी संकलन",
      description: "पर्यावरण जागरूकता के लिए कलात्मक प्रस्तुति",
      category: "कला संकलन",
    },
  ];

  return (
    <section id="gallery" className="gallery">
      <div className="container">
        <div className="gallery-header">
          <h2 className="section-title">📸 हमारी गतिविधियां</h2>
          <p className="section-subtitle">
            कटनी जिले में हमारे द्वारा किए गए शहर सफाई और पर्यावरण संरक्षण
            कार्यों की व्यापक झलकियां
          </p>
        </div>

        <div className="gallery-grid">
          {galleryItems.map((item, index) => (
            <div key={index} className="gallery-item">
              <div className="gallery-image">
                <img
                  src={item.src}
                  alt={item.title}
                  loading="lazy"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
                <div className="gallery-overlay">
                  <div className="gallery-content">
                    <div className="category-badge">{item.category}</div>
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="gallery-stats">
          <div className="stat-card">
            <span className="stat-icon">📸</span>
            <div className="stat-content">
              <span className="stat-number">30+</span>
              <span className="stat-label">प्रोजेक्ट फोटो</span>
            </div>
          </div>
          <div className="stat-card">
            <span className="stat-icon">🏆</span>
            <div className="stat-content">
              <span className="stat-number">7</span>
              <span className="stat-label">सक्रिय प्रोजेक्ट्स</span>
            </div>
          </div>
          <div className="stat-card">
            <span className="stat-icon">🌍</span>
            <div className="stat-content">
              <span className="stat-number">10+</span>
              <span className="stat-label">सफाई क्षेत्र</span>
            </div>
          </div>
          <div className="stat-card">
            <span className="stat-icon">👥</span>
            <div className="stat-content">
              <span className="stat-number">1000+</span>
              <span className="stat-label">लाभान्वित नागरिक</span>
            </div>
          </div>
        </div>

        <div className="environment-message">
          <div className="message-content">
            <h3>🤝 शहर की सफाई में हमारा साथ दें</h3>
            <p>
              हर छोटा कदम मायने रखता है। आज ही हमारे स्वच्छता मिशन से जुड़ें और
              एक साफ-सुथरे शहर के निर्माण में अपना योगदान दें।
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
